import React, { useState, useEffect } from 'react';

interface AnimatedNumberProps {
  number: number;
  startAnimation: boolean;
}

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ number, startAnimation }) => {
  const [currentNumber, setCurrentNumber] = useState<number>(0);

  useEffect(() => {
    if (!startAnimation) return;

    const animationDuration = 1000; // in ms
    const frameDuration = 1000 / 60; // 60fps
    const totalFrames = Math.round(animationDuration / frameDuration);
    const easeOutQuad = (t: number): number => t * (2 - t);
    let frame = 0;

    const counter = setInterval(() => {
      frame++;
      const progress = easeOutQuad(frame / totalFrames);
      const newNumber = Math.round(number * progress);

      if (frame === totalFrames) {
        setCurrentNumber(number);
        clearInterval(counter);
      } else {
        setCurrentNumber(newNumber);
      }
    }, frameDuration);

    return () => clearInterval(counter);
  }, [number, startAnimation]);

  return <span>{currentNumber}</span>;
};

export default AnimatedNumber;
